import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HeadPage } from 'src/components/elements'
import WishlistItems from './items/WishlistItems'
import FavoritesFeed from './feed/FavoritesFeed'

interface IWishlist {}

const Wishlist: FC<IWishlist> = () => {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-4">
      <HeadPage className="hidden md:flex" title={t('favorites')} />
      {/* News feed of changes to hearted listings (C3), above the saved items. */}
      <FavoritesFeed />
      <WishlistItems />
    </div>
  )
}

export default Wishlist
